// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2HQ4b","label":"Labeled_label__BHcZ5","divider":"Labeled_divider__3Gsjz"};